{
  "blocks": [
    {
      "id": "proc-ovarian-stimulation",
      "kind": "procedure",
      "tags": ["ivf", "egg-freezing", "her", "during-cycle"],
      "title": "Ovarian Stimulation",
      "subtitle": "Multi-day hormone injection protocol to grow multiple follicles",
      "body": {
        "procedureName": "Ovarian Stimulation",
        "category": "stimulation",
        "description": "Multi-day hormone injection protocol to grow multiple follicles. Used in IVF, egg freezing, and sometimes IUI.",
        "howItWorks": "Daily injections of gonadotropins (FSH, sometimes LH) for 8-14 days stimulate the ovaries to develop multiple follicles simultaneously. Monitoring with ultrasound and blood work every 1-3 days tracks follicle growth and estradiol. Follicles often grow about 1-2 mm per day, and estradiol rises as follicles mature. Doses are adjusted based on response. When the cohort is ready, the clinic times the trigger shot; retrieval is often scheduled about 36 hours later, but timing depends on the protocol.",
        "duration": "8-14 days",
        "painAndComfort": [
          "Injection sites may sting briefly, and bloating or pelvic pressure can develop as follicles grow."
        ],
        "whatToExpect": [
          "Bloating and abdominal fullness as follicles grow",
          "Frequent clinic visits for monitoring (every 1-3 days)",
          "Daily self-administered injections (subcutaneous)",
          "Emotional ups and downs from hormone changes",
          "Mild discomfort near the end as ovaries enlarge"
        ],
        "prepInstructions": [
          "Ask your clinic to demonstrate the first injection or confirm which training videos match your exact medication and device",
          "Keep medication storage instructions visible, especially for refrigerated injectables",
          "Expect dose changes after monitoring visits; do not adjust doses unless your clinic tells you to"
        ],
        "results": [
          {
            "label": "Follicle growth",
            "detail": "Follicles often grow about 1-2 mm per day during stimulation, but the full cohort matters more than one follicle."
          },
          {
            "label": "Estradiol trend",
            "detail": "Rising E2 confirms follicle response. Each mature follicle often contributes roughly 200-300 pg/mL, but clinics interpret the trend with ultrasound findings."
          },
          {
            "label": "Trigger readiness",
            "detail": "Lead follicles around 18-20 mm are often considered ready for trigger, though clinic protocols vary."
          },
          {
            "label": "Retrieval timing",
            "detail": "Egg retrieval is often scheduled about 36 hours after the trigger shot, but your clinic's exact instruction is the one to follow."
          }
        ],
        "risks": [
          "Ovarian hyperstimulation syndrome (OHSS)",
          "Multiple pregnancy if used with IUI",
          "Mild bruising at injection sites",
          "Mood changes and fatigue"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Stimulation ovarienne",
          "description": "Protocole d'injections hormonales sur plusieurs jours pour faire croître plusieurs follicules. Utilisé en FIV (fécondation in vitro), en vitrification ovocytaire et parfois en IIU (insémination intra-utérine).",
          "howItWorks": "Injections quotidiennes de gonadotrophines (FSH, parfois LH) pendant 8 à 14 jours pour stimuler les ovaires à développer plusieurs follicules simultanément. Le suivi par échographie et bilan sanguin tous les 1 à 3 jours permet de surveiller la croissance folliculaire et l'estradiol. Les follicules grossissent souvent d'environ 1 à 2 mm par jour, et l'estradiol augmente avec la maturation folliculaire. Les doses sont ajustées selon la réponse. Lorsque la cohorte est prête, le centre planifie le déclenchement; la ponction est souvent prévue environ 36 heures plus tard, mais le timing dépend du protocole.",
          "duration": "8 à 14 jours",
          "whatToExpect": [
            "Ballonnements et sensation de plénitude abdominale au fur et à mesure de la croissance folliculaire",
            "Rendez-vous fréquents pour le monitorage (tous les 1 à 3 jours)",
            "Injections quotidiennes en auto-administration (sous-cutanée)",
            "Hauts et bas émotionnels liés aux variations hormonales",
            "Léger inconfort en fin de stimulation à mesure que les ovaires grossissent"
          ],
          "risks": [
            "Syndrome d'hyperstimulation ovarienne (SHO)",
            "Grossesse multiple en cas d'association à une IIU",
            "Légères ecchymoses aux points d'injection",
            "Changements d'humeur et fatigue"
          ],
          "prepInstructions": [
            "Demandez au centre de vous montrer la première injection ou de confirmer quelles vidéos correspondent exactement à votre médicament et dispositif",
            "Gardez les consignes de conservation visibles, surtout pour les injectables réfrigérés",
            "Attendez-vous à des changements de dose après les rendez-vous de suivi; ne modifiez pas les doses sans consigne du centre"
          ],
          "results": [
            {
              "label": "Croissance folliculaire",
              "detail": "Les follicules grossissent souvent d'environ 1 à 2 mm par jour pendant la stimulation, mais l'ensemble de la cohorte compte plus qu'un seul follicule."
            },
            {
              "label": "Tendance de l'estradiol",
              "detail": "La hausse de l'E2 confirme la réponse folliculaire. Chaque follicule mature contribue souvent environ 200 à 300 pg/mL, mais les centres interprètent la tendance avec l'échographie."
            },
            {
              "label": "Prêt pour le déclenchement",
              "detail": "Des follicules dominants autour de 18 à 20 mm sont souvent considérés prêts pour le déclenchement, mais les protocoles varient."
            },
            {
              "label": "Timing de la ponction",
              "detail": "La ponction est souvent prévue environ 36 heures après le déclenchement, mais il faut suivre l'horaire exact donné par votre centre."
            }
          ]
        }
      },
      "sources": [
        {
          "title": "ESHRE guideline: ovarian stimulation for IVF/ICSI",
          "authors": "ESHRE Guideline Group on Ovarian Stimulation",
          "journal": "Human Reproduction Open",
          "year": 2020,
          "url": "https://academic.oup.com/hropen/article/2020/2/hoaa009/5826933",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
